import axios from 'axios';
import { SplashApi } from '../constants/API';
import { toast } from 'react-toastify';


export const api = axios.create({
    baseURL:'https://medicalradar.es/',
});

export const apiAdmin = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// ✅ Request Interceptor — attach token from localStorage
apiAdmin.interceptors.request.use(
  config => {
    try {
      const signupData = JSON.parse(localStorage.getItem('SignupData'));
      const token = signupData?.data?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error('Error reading token from localStorage:', err);
    }
    return config;
  },
  error => Promise.reject(error)
);

// ❌ Response Interceptor — handle 401 errors globally
apiAdmin.interceptors.response.use(
  response => {
    // Check if response indicates unauthenticated
    if (
      response?.data?.action === "Unauthenticated request" ||
      response?.data?.error === "Unauthenticated."
    ) {
    toast.error('Session expired. Please log in again.');

  setTimeout(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }, 500); // Adjust timing if needed
    }
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      // Clear localStorage and sessionStorage
      localStorage.clear();
      sessionStorage.clear();
      // Redirect to login page if not already there
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export const getSplashData = () => {
    const token = JSON.parse(localStorage.getItem('SignupData'))?.data?.token;
    return apiAdmin.get(SplashApi,{
        headers: {
          Authorization: `Bearer ${token}`, // Ensure token is passed correctly
        },
      });
};
